import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { Button, Modal, Divider, Input, Space, message } from 'antd';
import addToInventory from './graphql';
import { masterLookupForItem } from '../../graphql/item';

import getCodeDefinitions from '../../graphql/codeDefinitions';
// import requestOrganizationById from '../../pages/ToolingManagement/graphql';
import { isNationalItemIdentificationNumber } from '../../utils/validationUtils';

export default function AddInventoryHOC(AddInventoryPage) {
  class WrappedComponent extends Component {
    static propTypes = {
      auth: PropTypes.shape({
        id: PropTypes.string,
        role: PropTypes.string,
        expiration: PropTypes.number,
        organizationId: PropTypes.string,
        email: PropTypes.string.isRequired,
        cageCode: PropTypes.string.isRequired,
      }).isRequired,
      onReturnToMainPage: PropTypes.func.isRequired,
    };

    static initialState = {
      formValues: {
        ui: {
          selectValueA: 'EA',
          displayValues: [],
        },
        qup: {
          selectValueC: '1',
          displayValues: [],
        },
        visibility: {
          selectValueB: 'true',
          displayValues: [
            {
              value: 'true',
              text: 'Public'
            }, {
              value: 'false',
              text: "Gov't Only"
            }
          ],
        },

        partNum: '',
        niin: '',
        description: '',
        price: "0.0",
        soh: "0",

        masterToolingId: '',

      },
      isLoading: true,
      errors: [],
      alertType: '',
      alertMessage: '',
      modalOpen: true,


    };

    state = WrappedComponent.initialState;

    async componentDidMount() {
      const uiOptions = this._createOptions(await getCodeDefinitions("UI"));
      const qupOptions = this._createOptions(await getCodeDefinitions("QUP"));

      // this.setState({
      //   cage: this.props.auth.cageCode,
      // });

      // CATHARINA TODO use old state
      const formValues = { ...this.state.formValues };
      formValues.ui.displayValues = uiOptions;
      formValues.qup.displayValues = qupOptions;

      this.setState({ formValues });
    }

    _createOptions = arr => {
      const options = arr.map(code => ({ text: code.codeDefinition, value: code.codeValue }));
      return options;
    };

    _handleInitalValueReset = () => {
      // CATHARINA TODO use old state
      const formValues = { ...this.state.formValues };

      formValues.ui.selectValueA = 'EA';
      formValues.qup.selectValueC = '1';
      formValues.visibility.selectValueB = 'true';

      this.setState({ formValues });
    };

    _hideMessage = () => this.setState({ alertMessage: '', alertType: '' });

    _onSubmit = async event => {
      const { auth } = this.props;

      const {
        niin,
        description = '',
        partNum = '',
        cage = auth.cageCode,
        price = '',
        ui = '',
        qup = '',
        soh = '',
        visibility,

      } = event;

      const obj = {
        cage: `${cage}`,
        partNum: `${partNum}`,
        niin: `${niin}`,
        modifiedBy: `${auth.email}`,
        price: `${price}` || '0.0',
        ui: `${ui.selectValueA}` || 'EA',
        qup: `${qup.selectValueC}` || '1',
        soh: `${soh}` || '0',
        visibility: `${visibility.selectValueB}` || 'true',
        description: `${description}`,
      }



      try {
        const { addInventory } = await addToInventory({
          ...obj,
        });
        if (addInventory.status === 'success') {
          message.info("Inventory record added to database.");
          setTimeout(() => this.props.onReturnToMainPage(), 1000);
        } else {
          message.error("Failed to add Inventory record to database. Record may already exists.");
        }
      } catch (error) {
        message.error("Failed to add Inventory record to database. You may not have the permissions.");
      }
    };

    enableAddInventoryBtn = () => {
      if (document.getElementById("btnAddInventory")) {
        document.getElementById("btnAddInventory").disabled = false;
        document.getElementById("btnAddInventory").className = "nf-button nf-button--form nf-button--orange btn btn-secondary";
      }
    };



    onChange = e => {
      const value = e.target.value;
      const name = e.target.name;

      this.setState(prevState => ({
        formValues: {
          ...prevState.formValues,
          [name]: value,
        }
      }))
    };

    handleOkToolingLookup = async () => {
      if (!!this.state.formValues.partNum && !!this.state.formValues.niin) {

        if (isNationalItemIdentificationNumber(this.state.formValues.niin)) {
          message.error('Part NIIN should contain nine digits and no other characters!', 6);
          return;
        }

        const obj = {
          cage: this.props.auth.cageCode,
          partNum: this.state.formValues.partNum,
          niin: this.state.formValues.niin,
          searchType: "I"
        }


        try {
          const { masterLookupItem } = await masterLookupForItem({
            ...obj,
          });

          console.log('lookup item master in DB2 => ', masterLookupItem);
          if (masterLookupItem.isInventoryExist) {
            message.error('Inventory already exist in database!', 6);
          } else if (masterLookupItem.inventoryManagementData.masterTblRecInserted === true) {
            message.info('Master Tooling record added! Please finish adding inventory by using the Add Inventory form below.', 10);
            this.closeModal();
            this.enableAddInventoryBtn();
          } else {
            message.info('Found master record and data is shown.', 6);
            this.closeModal();
            this.enableAddInventoryBtn();
            if (document.getElementById('description')) {
              document.getElementById('description').setAttribute('disabled', true);
            }
          }

          if (masterLookupItem.inventoryManagementData) {
            const formValues = { ...this.state.formValues };
            formValues.description = masterLookupItem.inventoryManagementData.description;
            formValues.comments = masterLookupItem.inventoryManagementData.comments;
            formValues.masterToolingId = masterLookupItem.inventoryManagementData.id;
            this.setState({ formValues });
          }
        } catch (error) {
          message.error('Part Number and NSN lookup failed.', 6);
        }
      } else {
        message.error('Part Number and NSN are a required fields! Please enter a Part Number and a valid NSN!', 6);
      }
    };

    openToolingModal = () => {
      this.setState({
        modalOpen: true
      });
    };

    closeModal = () => {
      this.setState({
        modalOpen: false
      });
    };

    render() {
      const { onReturnToMainPage } = this.props;
      const {
        formValues,
        alertType,
        alertMessage,
        modalOpen,
      } = this.state;

      // Configure Page
      const pageProps = {
        formValues,
        onSubmit: this._onSubmit,
        alertType,
        alertMessage,
        hideMessage: this._hideMessage,
        handleInitalValueReset: this._handleInitalValueReset,
        onReturnToMainPage
      };

      return (
        <Container style={{ width: '85vw', maxWidth: 'none' }}>
          <AddInventoryPage {...pageProps}
          />

          <Modal
            title="Add Inventory Record"
            visible={modalOpen}
            onOk={this.handleOkToolingLookup}
            onCancel={onReturnToMainPage}

            footer={[
              <Button key="back" className="nf-button nf-button--gray-border btn btn-secondary"
                onClick={onReturnToMainPage}>
                Cancel
              </Button>,
              <Button className="nf-button nf-button--form nf-button--orange btn btn-secondary"
                key="submit"
                type="primary"
                disabled={!this.state.formValues.niin || !this.state.formValues.partNum}
                onClick={this.handleOkToolingLookup}
              >
                Submit
              </Button>,
            ]}
          >
            <Space direction="vertical" >
              <Input name='partNum' id='partNum' addonBefore="Part Number *" placeholder="Add part number (Required)" value={this.state.formValues.partNum} onChange={this.onChange} />
              <Input name='niin' id='niin' addonBefore="NIIN *" placeholder="Add NIIN (Required)" value={this.state.formValues.niin} onChange={this.onChange} />
            </Space>
            <Divider plain />
          </Modal>
        </Container>

      );
    }
  }

  return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/components/AddInventory/AddInventoryHOC.jsx